import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import type { UserProfile } from "./Sidebar";

function getUserFromStorage(): UserProfile | null {
  try {
    const raw = localStorage.getItem("convivencia_user");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && parsed.id && parsed.rol) return parsed as UserProfile;
    return null;
  } catch {
    return null;
  }
}

export default function ProtectedLayout() {
  const user = getUserFromStorage();

  return (
    <AuthGuard user={user}>
      <Outlet />
    </AuthGuard>
  );
}